var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDoubleArrowNext(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDoubleArrowNext") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-arrows",
    transform: "translate(-171.000000, -611.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.364321,620.352418 L180.351817,611.367993 C180.843754,610.877299 181.641618,610.877299 182.133778,611.368216 C182.625803,611.860241 182.625803,612.657626 182.133757,613.14843 L174.037164,621.243073 L182.13455,629.337536 C182.626836,629.828579 182.626836,630.626137 182.134327,631.117402 C181.641409,631.607837 180.844713,631.607837 180.352619,631.116986 L171.3654,622.132754 C170.878558,621.64695 170.878202,620.839784 171.364321,620.352418 Z M179.364321,620.352418 L188.351817,611.367993 C188.843754,610.877299 189.641618,610.877299 190.133778,611.368216 C190.625803,611.860241 190.625803,612.657626 190.133757,613.14843 L182.037164,621.243073 L190.13455,629.337536 C190.626836,629.828579 190.626836,630.626137 190.134327,631.117402 C189.641409,631.607837 188.844713,631.607837 188.352619,631.116986 L179.3654,622.132754 C178.878558,621.64695 178.878202,620.839784 179.364321,620.352418 Z",
    id: "icDoubleArrowNext",
    transform: "translate(180.751868, 621.242588) rotate(180.000000) translate(-180.751868, -621.242588) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoubleArrowNext);
export default __webpack_public_path__ + "static/media/icDoubleArrowNext.0af77973b6d2b3a2386da98ea4b0284c.svg";
export { ForwardRef as ReactComponent };